document.querySelectorAll('.glider-slider').forEach(function (sectionGliderTarget) {
  var mySectionId = sectionGliderTarget.getAttribute('data-glider-id');
  new Glider(mySectionId, {
    slidesToShow: 1.5,
    slidesToScroll: 1,
    draggable: true,
    resizeLock: true,
    arrows: {
      prev: '#glider-prev',
      next: '#glider-next',
    },
    responsive: [
      {
        // screens greater than >= 750px
        breakpoint: 750,
        settings: {
          // Set to `auto` and provide item width to adjust to viewport
          slidesToShow: 2.5,
          slidesToScroll: 1,
          itemWidth: 150,
          duration: 0.25,
        },
      },
      {
        // screens greater than >= 991px
        breakpoint: 991,
        settings: {
          // Set to `auto` and provide item width to adjust to viewport
          slidesToShow: 3.5,
          slidesToScroll: 3,
          itemWidth: 150,
          duration: 0.25,
        },
      },
      {
        // screens greater than >= 1024px
        breakpoint: 1024,
        settings: {
          // Set to `auto` and provide item width to adjust to viewport
          slidesToShow: 4.5,
          slidesToScroll: 4,
          itemWidth: 150,
          duration: 0.25,
        },
      },
      {
        // screens greater than >= 1280px
        breakpoint: 1280,
        settings: {
          slidesToShow: 5.5,
          slidesToScroll: 5,
          itemWidth: 150,
          duration: 0.25,
        },
      },
    ],
  });
});